var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.items && !!_vm.items.length)?_c('ul',{class:_vm.classObject},_vm._l((_vm.items),function(item,index){return _c('nav-item',{key:index,attrs:{"item":item}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }